<template>
  <div class="home-page">
    <div
      :class="{
        'home-page-block-1': true,
        '--started-1': startAnim,
        '--started-2': startAnim2,
      }"
    >
      <img class="_light" src="../assets/img/404-light.webp" />
      <img
        class="_light _light--mob"
        src="../assets/img/home/mobile-first-block-light.webp"
      />
      <div class="home-page-block-1__content">
        <span class="_kr-left-wrap">
          <img class="_kr-left" src="../assets/img/kr-left.webp" />
        </span>
        <span class="_kr-right-wrap">
          <img class="_kr-right" src="../assets/img/kr-right.webp" />
        </span>
        <img class="_logo" src="../assets/img/logo.svg" alt="" />
        <div class="_text">
          <div class="_row-1">Яркий вкус</div>
          <div class="_row-subtitle">для ярких моментов</div>
        </div>
      </div>
      <span class="home-page-block-1__arrow-wrap">
        <ArrowDown />
      </span>
    </div>
    <div class="seasonal-block">
      <img class="seasonal-block__light" :src="seasonalLightSrc" :style="seasonalLightStyle" alt="" />
      <img class="seasonal-block__left" :src="seasonalLeftSrc" alt="" />
      <img class="seasonal-block__right" src="../assets/img/right.svg" alt="" />
      <div class="seasonal-block__header">
        <h2 class="seasonal-block__title">ВСТРЕЧАЙТЕ ЛЕТНИЙ ВКУС</h2>
        <div class="seasonal-block__subtitle">в мини формате</div>
      </div>
    </div>
    <!-- <div class="mini-format">
      <img
        class="mini-format__words --desc"
        src="../assets/img/mini-format/words.svg"
      />
      <img
        class="mini-format__words --mob"
        src="../assets/img/home/mobile-mini-format-title.svg"
      />
    </div> -->
    <ProductSlider @slide-change="onSlideChange" />
    <NumberOne />
    <BrightBlock />


    <Reviews />
    <WhereBuy :fullVersion="true" />
  </div>
</template>

<script>
import Reviews from "@/components/Reviews.vue"
import ProductSlider from "@/components/ProductSlider.vue"
import NumberOne from "@/components/NumberOne.vue"
import BrightBlock from "@/components/BrightBlock.vue"
import WhereBuy from "@/components/WhereBuy.vue"
import ArrowDown from "@/components/ArrowDown.vue"

export default {
  name: "HomeView",
  components: {
    ProductSlider,
    NumberOne,
    BrightBlock,
    Reviews,
    WhereBuy,
    ArrowDown,
  },
  data() {
    return {
      startAnim: false,
      startAnim2: false,
      currentSliderSlide: 9,
      isMobile: window.innerWidth <= 920,
    }
  },
  computed: {
    seasonalLeftSrc() {
      return this.isMobile
        ? require("../assets/img/left_mob.svg")
        : require("../assets/img/left.svg")
    },
    seasonalLightSrc() {
      const id = this.currentSliderSlide
      if (id >= 7 || id === 9) return require("../assets/img/triangle1.svg")
      return require("../assets/img/trangle.svg")
    },
    seasonalLightStyle() {
      return this.currentSliderSlide === 9
        ? { transform: "translateX(70px)" }
        : { transform: "translateX(17px)" }
    },
  },
  mounted() {
    setTimeout(() => {
      this.startAnim = true
    }, 200)
    setTimeout(() => {
      this.startAnim2 = true
    }, 500)
    this._onResize = () => { this.isMobile = window.innerWidth <= 920 }
    window.addEventListener("resize", this._onResize)
  },
  unmounted() {
    window.removeEventListener("resize", this._onResize)
  },
  methods: {
    onSlideChange({ id }) {
      this.currentSliderSlide = id
    },
  },
}
</script>

<style lang="scss">
.home-page-block-1 {
  min-height: 100vh;
  @include respond-to("smartphone-plus") {
    height: var(--app-height);
  }
  background-color: $color-yellow;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  &__arrow-wrap {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10%;
    z-index: 10;
  }
  ._light {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 100%;
    z-index: 0;
    transform: translate(-40%, -40%);
    opacity: 0;
    // transform: translateY(100px);
    transition: all 0.3s ease-in;
    // transition-delay: 0.8s;
  }
  ._light--mob {
    display: none;
  }
  &__content {
    height: 275px;
    position: relative;
    ._kr-left,
    ._kr-right {
      height: 275px;
      position: relative;
      transition: all 0.5s ease-out;
      transition-delay: 0.3s;
    }
    ._kr-left {
      z-index: 10;
      transform: translate(80px, 7px);
      top: 0px;
      left: 0px;
    }
    ._kr-right {
      z-index: 9;
      transform: translateX(-10px);
    }
    ._kr-left-wrap {
      position: relative;
      z-index: 10;
    }
    ._kr-right-wrap {
      position: relative;
      z-index: 9;
    }
    ._logo {
      position: absolute;
      top: 60%;
      left: 50%;
      width: 164px;
      transform: translate(-50%, -120%);
      opacity: 0;
      transition: all 0.2s ease-in;
      transition-delay: 1s;
    }
    ._text {
      top: -140px;
      position: relative;
      font-family: $font-peach;
      font-size: 10.5rem;
      color: $color-blue;
      text-align: center;
      line-height: 0.7;
      opacity: 0;
      transition: all 0.2s ease-in;
      transition-delay: 1s;
      > div + div {
        margin-top: 32px;
      }
      ._row-1 {
        transform: rotate(-4.7deg);
      }
      ._row-2 {
        transform: rotate(1.7deg);
      }
      ._row-subtitle {
        color: #00188a;
        font-family: $font-peach;
        font-size: 4.2rem;
        font-style: normal;
        font-weight: 400;
        line-height: 100%;
        letter-spacing: 1.68px;
        text-transform: uppercase;
        transform: rotate(-4.72deg);
        margin-top: 16px;
      }
    }
  }
  &.--started-1 {
    ._light {
      opacity: 1;
      transform: translate(-40%, -50%);
    }
  }
  &.--started-2 {
    ._kr-left-wrap {
      animation: vibrate-1 0.3s;
    }
    ._kr-right-wrap {
      animation: vibrate-2 0.3s;
    }
    ._kr-left {
      top: 0px;
      left: 0px;
      transform: translate(-280px, 61px) rotate(-20deg);
    }
    ._kr-right {
      transform: translate(280px, 56px) rotate(20deg);
    }
    ._logo {
      width: 224px;
      opacity: 1;
    }
    ._text {
      opacity: 1;
    }
  }
  @include respond-to("small") {
    .home-page-block-1__content {
      ._text {
        font-size: 9.2rem;
      }
    }
    &.--started-2 ._logo {
      width: 180px;
      transform: translate(-50%, -200px);
    }
    &__content ._text{
      top: -80px;
    }
    &__content ._kr-left,
    &__content ._kr-right {
      height: 225px;
    }
  }
  @media screen and (max-height: 680px) and (min-width: 1200px) {
    .home-page-block-1__content {
      ._text {
        font-size: 9.2rem;
        top: -80px;
      }
    }
    &.--started-2 ._logo {
      width: 180px;
      transform: translate(-50%, -200px);
    }
  }

  @include respond-to("smartphone-plus") {
    overflow: hidden;
    ._light {
      display: none;
    }
    ._light--mob {
      display: block;
    }
    .home-page-block-1__content {
      height: auto;
      ._kr-left,
      ._kr-right {
        height: 155px;
        // display: none;
      }
      ._kr-left {
        // transform: translate(-280px, 61px) rotate(-45deg);
      }
      ._kr-right {
        // transform: translate(280px, 56px) rotate(45deg);
      }
      ._text {
        font-size: 5.3rem;
        top: -40px;
        div + div {
          margin-top: 18px;
        }
        ._row-subtitle {
          font-size: 3.5rem;
        }
      }
      ._logo {
        width: 112px;
        transform: translate(-50%, -150%);
      }
    }
    &.--started-2 {
      ._kr-left {
        transform: translate(-30px, -161px) rotate(45deg) !important;
      }
      ._kr-right {
        transform: translate(50px, 246px) rotate(45deg) !important;
      }
    }
  }
}
.mini-format {
  background: url(../assets/img/mini-format/bg.jpg) no-repeat center;
  background-size: cover;
  min-height: 100vh;
  position: relative;
  &__words {
    position: absolute;
    left: 52%;
    top: 17%;
    &.--mob {
      display: none;
    }
  }
  @include respond-to("small") {
    .mini-format__words {
      width: 40%;
    }
  }
  @include respond-to("smartphone-plus") {
    background: url(../assets/img/home/mobile-mini-format.webp) no-repeat center;
    background-size: cover;
    margin-top: -40px;
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;

    .mini-format__words {
      display: none;
    }
    .mini-format__words.--mob {
      display: block;
      left: 50%;
      top: 50px;
      transform: translate(-50%, 0);
    }
  }
  
  @media screen and (max-width: 610px) {
    .mini-format__words.--mob {
      width: 60%;
    }
  }
  
  @media screen and (max-width: 500px) {
    .mini-format__words.--mob {
      width: 80%;
    }
  }
}
.seasonal-block {
  width: 100%;
  height: 800px;
  background: #08a1bc;
  position: relative;
  overflow: hidden;

  &__left {
    position: absolute;
    right: calc(50% - 20px);
    top: 50%;
    width: 1182px;
    z-index: 1;
    transform: translate(26%, -48%);
  }

  &__right {
    position: absolute;
    left: calc(50% - 50px);
    top: 50%;
    width: 797px;
    z-index: 2;
    transform: translate(-5%, -49%);
  }

  &__light {
    position: absolute;
    top: 0;
    height: 100%;
    left: 50%;
    transform: translateX(17px);
    z-index: 0;
  }

  &__product {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: auto;
    z-index: 1;
  }

  &__bg-svg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    display: block;
    height: calc(100% + 4px);
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
    padding-top: 3px;
    transform: rotate(356deg) translateX(-135px);
  }

  &__title {
    font-family: $font-peach;
    font-size: 10.1475rem;
    font-style: normal;
    font-weight: 400;
    line-height: 114.18px;
    letter-spacing: 2.03px;
    text-transform: uppercase;
    text-align: center;
    color: #00188a;
    margin: 0;
    white-space: nowrap;
  }

  &__subtitle {
    font-family: $font-peach;
    font-size: 4.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.84px;
    text-transform: uppercase;
    text-align: center;
    color: #de000d;
    white-space: nowrap;
  }

  @media (min-width: 1300px) and (max-width: 1399px) {
    &__left {
      right: calc(50% - 20px);
    }
  }

  @media (min-width: 1200px) and (max-width: 1299px) {
    &__left {
      right: calc(45% - 20px);
    }
    &__right {
      left: calc(50% - 81px);
      top: 53%;
    }
  }

  @include respond-to("smartphone-plus") {
    height: auto;
    min-height: max(1023px, 110vh);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    &__header {
      transform: rotate(358deg) translateX(9px);
      padding-top: 11px;
      padding-bottom: 20px;
      order: 1;
    }

    &__title {
      font-size: 5.5rem;
      line-height: 1.1;
      letter-spacing: 1px;
      white-space: normal;
      text-align: center;
      max-width: 320px;
    }

    &__subtitle {
      font-size: 2.8rem;
    }

    &__left {
      position: absolute;
      right: auto;
      left: 43%;
      top: -61px;
      width: 139%;
      max-width: 1000px;
      transform: translateX(-50%);
      z-index: 1;
    }

    &__right {
      position: absolute;
      left: auto;
      right: -6%;
      bottom: 9%;
      top: auto;
      width: 90%;
      max-width: 420px;
      transform: none;
      z-index: 2;
    }

    &__light {
      display: none;
    }
  }
}

</style>
